/*
 * =====================================================================================
 * DISCLAIMER:
 * =====================================================================================
 * This localization file is a community contribution and is not officially maintained
 * by Clerk. It has been provided by the community and may not be fully aligned
 * with the current or future states of the main application. Clerk does not guarantee
 * the accuracy, completeness, or timeliness of the translations in this file.
 * Use of this file is at your own risk and discretion.
 * =====================================================================================
 */

import type { LocalizationResource } from '@clerk/shared/types';

export const kkKZ: LocalizationResource = {
  locale: 'kk-KZ',
  apiKeys: {
    action__add: undefined,
    action__search: undefined,
    copySecret: {
      formButtonPrimary__copyAndClose: 'Көшіру және жабу',
      formHint: 'Қауіпсіздік себептерімен, біз сізге кейінірек оны қайта көруге рұқсат бере алмаймыз.',
      formTitle: 'API кілтіңізді "{{name}}" қазір көшіріңіз',
    },
    createdAndExpirationStatus__expiresOn: undefined,
    createdAndExpirationStatus__never: undefined,
    detailsTitle__emptyRow: undefined,
    formButtonPrimary__add: undefined,
    formFieldCaption__expiration__expiresOn: undefined,
    formFieldCaption__expiration__never: undefined,
    formFieldOption__expiration__180d: undefined,
    formFieldOption__expiration__1d: undefined,
    formFieldOption__expiration__1y: undefined,
    formFieldOption__expiration__30d: undefined,
    formFieldOption__expiration__60d: undefined,
    formFieldOption__expiration__7d: undefined,
    formFieldOption__expiration__90d: undefined,
    formFieldOption__expiration__never: undefined,
    formHint: undefined,
    formTitle: undefined,
    lastUsed__days: undefined,
    lastUsed__hours: undefined,
    lastUsed__minutes: undefined,
    lastUsed__months: undefined,
    lastUsed__seconds: undefined,
    lastUsed__years: undefined,
    menuAction__revoke: undefined,
    revokeConfirmation: {
      confirmationText: undefined,
      formButtonPrimary__revoke: undefined,
      formHint: undefined,
      formTitle: undefined,
    },
  },
  backButton: 'Артқа',
  badge__activePlan: undefined,
  badge__canceledEndsAt: undefined,
  badge__currentPlan: 'Ағымдағы жоспар',
  badge__default: 'Әдепкі бойынша',
  badge__endsAt: "{{ date | shortDate('kk-KZ') }} күні аяқталады",
  badge__expired: 'Мерзімі біткен',
  badge__freeTrial: undefined,
  badge__otherImpersonatorDevice: 'Басқа эмуляциялаушы құрылғы',
  badge__pastDueAt: undefined,
  badge__pastDuePlan: undefined,
  badge__primary: 'Негізгі',
  badge__renewsAt: undefined,
  badge__requiresAction: 'Әрекет қажет',
  badge__startsAt: "{{ date | shortDate('kk-KZ') }} күні басталады",
  badge__thisDevice: 'Осы құрылғы',
  badge__trialEndsAt: undefined,
  badge__unverified: 'Расталмаған',
  badge__upcomingPlan: 'Алдағы жоспар',
  badge__userDevice: 'Пайдаланушы құрылғысы',
  badge__you: 'Сіз',
  billing: {
    addPaymentMethod__label: undefined,
    alwaysFree: undefined,
    annually: undefined,
    availableFeatures: undefined,
    billedAnnually: 'Жыл сайын ақы төленеді',
    billedMonthlyOnly: undefined,
    cancelFreeTrial: undefined,
    cancelFreeTrialAccessUntil: undefined,
    cancelFreeTrialTitle: undefined,
    cancelSubscription: 'Жазылымды болдырмау',
    cancelSubscriptionAccessUntil: undefined,
    cancelSubscriptionNoCharge: undefined,
    cancelSubscriptionPastDue: undefined,
    cancelSubscriptionTitle: undefined,
    cannotSubscribeMonthly: undefined,
    cannotSubscribeUnrecoverable: undefined,
    checkout: {
      description__paymentSuccessful: 'Сіздің жаңа жазылымыңыз дайын.',
      description__subscriptionSuccessful: 'Сіздің жаңа жазылымыңыз дайын.',
      downgradeNotice: undefined,
      emailForm: {
        subtitle: undefined,
        title: undefined,
      },
      lineItems: {
        title__freeTrialEndsAt: undefined,
        title__paymentMethod: 'Төлем әдісі',
        title__statementId: 'Шоттың ID нөмірі',
        title__subscriptionBegins: 'Жазылым басталады',
        title__totalPaid: 'Жалпы төленді',
      },
      pastDueNotice: undefined,
      perMonth: undefined,
      title: undefined,
      title__paymentSuccessful: 'Төлем сәтті аяқталды!',
      title__subscriptionSuccessful: 'Сәтті!',
      title__trialSuccess: undefined,
      totalDueAfterTrial: undefined,
    },
    credit: undefined,
    creditRemainder: undefined,
    defaultFreePlanActive: undefined,
    free: 'Тегін',
    getStarted: 'Бастау',
    keepFreeTrial: undefined,
    keepSubscription: 'Жазылымды сақтау',
    manage: 'Басқару',
    manageSubscription: 'Жазылымды басқару',
    month: 'Ай',
    monthly: undefined,
    pastDue: undefined,
    pay: undefined,
    paymentMethod: {
      applePayDescription: {
        annual: undefined,
        monthly: undefined,
      },
      dev: {
        anyNumbers: undefined,
        cardNumber: undefined,
        cvcZip: undefined,
        developmentMode: undefined,
        expirationDate: undefined,
        testCardInfo: undefined,
      },
    },
    paymentMethods__label: undefined,
    highlightedPlanBadge: undefined,
    pricingTable: {
      billingCycle: undefined,
      included: undefined,
    },
    reSubscribe: 'Қайта жазылу',
    seeAllFeatures: undefined,
    startFreeTrial: undefined,
    startFreeTrial__days: undefined,
    subscribe: undefined,
    subscriptionDetails: {
      beginsOn: undefined,
      currentBillingCycle: undefined,
      endsOn: undefined,
      firstPaymentAmount: undefined,
      firstPaymentOn: undefined,
      nextPaymentAmount: undefined,
      nextPaymentOn: undefined,
      pastDueAt: undefined,
      renewsAt: undefined,
      subscribedOn: undefined,
      title: undefined,
      trialEndsOn: undefined,
      trialStartedOn: undefined,
    },
    subtotal: undefined,
    switchPlan: 'Осы жоспарға ауысу',
    switchToAnnual: undefined,
    switchToAnnualWithAnnualPrice: undefined,
    switchToMonthly: undefined,
    switchToMonthlyWithPrice: undefined,
    totalDue: undefined,
    totalDueToday: undefined,
    viewFeatures: undefined,
    viewPayment: undefined,
    year: undefined,
  },
  configureSSO: {
    missingManageEnterpriseConnectionsPermission: {
      subtitle: 'Корпоративтік қосылыстарды басқару рұқсаттарын алу үшін ұйым әкімшісіне хабарласыңыз.',
      title: 'Сізде корпоративтік қосылыстарды басқаруға рұқсат жоқ',
    },
    navbar: {
      title: 'Бірыңғай кіруді конфигурациялау (SSO)',
    },
    selectProviderStep: {
      title: 'Select provider',
      subtitle: 'Select the provider you are going to setup SSO for.',
      body: {
        title: 'Select your identity provider',
        description: "We'll guide you through the detailed setup process next.",
      },
      saml: {
        groupLabel: 'SAML',
        okta: 'Okta Workforce',
        customSaml: 'Custom SAML Provider',
      },
      warning: 'Once a provider is selected you cannot change again until the configuration is over',
    },
    verifyEmailDomainStep: {
      title: 'Электрондық пошта мекенжайын растау',
      subtitle: 'Кәсіпорын байланысын іске қосқыңыз келетін электрондық пошта мекенжайын растаңыз.',
      addEmailAddress: {
        formTitle: 'Бізге электрондық поштаңыз қажет',
        formSubtitle: 'Бастау үшін электрондық пошта мекенжайыңыз қажет болады',
        inputPlaceholder: 'name@company.com',
        inputLabel: 'Электрондық пошта мекенжайы',
      },
      emailCode: {
        formTitle: 'Электрондық пошта мекенжайыңызды растаңыз',
        formSubtitle: '{{identifier}} мекенжайына жіберілген растау кодын енгізіңіз',
        resendButton: 'Код алмадыңыз ба? Қайта жіберу',
        verified: {
          title: 'Электрондық поштаңызды алдық',
          subtitle: 'Электрондық пошта мекенжайыңызды келесі поштамен растадыңыз',
          inputLabel: 'Расталған электрондық пошта мекенжайы',
        },
      },
      domainTaken: {
        title: 'Бұл доменде ({{domain}}) бұрыннан SSO байланысы бар',
        subtitle: 'Қолданыстағы байланыс арқылы кіруге қол жеткізу үшін қолданба әкімшісіне хабарласыңыз.',
      },
    },
  },
  createOrganization: {
    formButtonSubmit: 'Ұйым құру',
    invitePage: {
      formButtonReset: 'Өткізіп жіберу',
    },
    title: 'Ұйым құру',
  },
  dates: {
    lastDay: "Кеше {{ date | timeString('kk-KZ') }}",
    next6Days: "{{ date | weekday('kk-KZ','long') }} {{ date | timeString('kk-KZ') }}",
    nextDay: "Ертең {{ date | timeString('kk-KZ') }}",
    numeric: "{{ date | numeric('kk-KZ') }}",
    previous6Days: "Өткен {{ date | weekday('kk-KZ','long') }} {{ date | timeString('kk-KZ') }}",
    sameDay: "Бүгін {{ date | timeString('kk-KZ') }}",
  },
  dividerText: 'немесе',
  footerActionLink__alternativePhoneCodeProvider: undefined,
  footerActionLink__useAnotherMethod: 'Басқа әдісті қолдану',
  footerPageLink__help: 'Көмек',
  footerPageLink__privacy: 'Құпиялық',
  footerPageLink__terms: 'Шарттар',
  formButtonPrimary: 'Жалғастыру',
  formButtonPrimary__verify: 'Растау',
  formFieldAction__forgotPassword: 'Құпия сөзді ұмыттыңыз ба?',
  formFieldError__matchingPasswords: 'Құпия сөздер сәйкес келеді.',
  formFieldError__notMatchingPasswords: 'Құпия сөздер сәйкес келмейді.',
  formFieldError__verificationLinkExpired: 'Растау сілтемесінің мерзімі бітті. Жаңа сілтеме сұраңыз.',
  formFieldHintText__optional: 'Қосымша',
  formFieldHintText__slug: 'Slug - бұл бірегей ID. URL мекенжайларында жиі қолданылады.',
  formFieldInputPlaceholder__apiKeyDescription: undefined,
  formFieldInputPlaceholder__apiKeyExpirationDate: undefined,
  formFieldInputPlaceholder__apiKeyName: undefined,
  formFieldInputPlaceholder__backupCode: 'Сақтық кодын енгізіңіз',
  formFieldInputPlaceholder__confirmDeletionUserAccount: 'Есепті жою',
  formFieldInputPlaceholder__emailAddress: 'Электрондық поштаны енгізіңіз',
  formFieldInputPlaceholder__emailAddress_username: 'Электрондық поштаны немесе пайдаланушы атын енгізіңіз',
  formFieldInputPlaceholder__emailAddresses: undefined,
  formFieldInputPlaceholder__firstName: 'Аты',
  formFieldInputPlaceholder__lastName: 'Тегі',
  formFieldInputPlaceholder__organizationDomain: 'webfilter.com',
  formFieldInputPlaceholder__organizationDomainEmailAddress: 'siz@webfilter.com',
  formFieldInputPlaceholder__organizationName: 'Ұйым атауы',
  formFieldInputPlaceholder__organizationSlug: 'my-org',
  formFieldInputPlaceholder__password: 'Құпия сөзді енгізіңіз',
  formFieldInputPlaceholder__phoneNumber: 'Телефон нөмірін енгізіңіз',
  formFieldInputPlaceholder__username: undefined,
  formFieldInput__emailAddress_format: undefined,
  formFieldLabel__apiKey: 'API кілті',
  formFieldLabel__apiKeyDescription: 'Сипаттама',
  formFieldLabel__apiKeyExpiration: 'Мерзімі',
  formFieldLabel__apiKeyName: 'Құпия кілт атауы',
  formFieldLabel__automaticInvitations: 'Бұл доменге автошақыруларды қосу',
  formFieldLabel__backupCode: 'Сақтық коды',
  formFieldLabel__confirmDeletion: 'Растау',
  formFieldLabel__confirmPassword: 'Құпия сөзді растау',
  formFieldLabel__currentPassword: 'Ағымдағы құпия сөз',
  formFieldLabel__emailAddress: 'Электрондық пошта',
  formFieldLabel__emailAddress_username: 'Электрондық пошта немесе пайдаланушы аты',
  formFieldLabel__emailAddresses: 'Электрондық пошталар',
  formFieldLabel__firstName: 'Аты',
  formFieldLabel__lastName: 'Тегі',
  formFieldLabel__newPassword: 'Жаңа құпия сөз',
  formFieldLabel__organizationDomain: 'Домен',
  formFieldLabel__organizationDomainDeletePending: 'Күтудегі шақыруларды жою',
  formFieldLabel__organizationDomainEmailAddress: 'Растау электрондық поштасы',
  formFieldLabel__organizationDomainEmailAddressDescription:
    'Растау кодын алу үшін осы домен астындағы электрондық поштаны енгізіңіз.',
  formFieldLabel__organizationName: 'Атауы',
  formFieldLabel__organizationSlug: 'Slug',
  formFieldLabel__passkeyName: 'Құпия кілт атауы',
  formFieldLabel__password: 'Құпия сөз',
  formFieldLabel__phoneNumber: 'Телефон нөмірі',
  formFieldLabel__role: 'Рөлі',
  formFieldLabel__signOutOfOtherSessions: 'Барлық басқа құрылғылардан шығу',
  formFieldLabel__username: 'Пайдаланушы аты',
  impersonationFab: {
    action__signOut: 'Шығу',
    title: '{{identifier}} ретінде кірдіңіз',
  },
  lastAuthenticationStrategy: 'Соңғы пайдаланылған',
  maintenanceMode: 'Қазір техникалық қызмет көрсету жұмыстары жүріп жатыр, бірақ бірнеше минуттан аспайды.',
  membershipRole__admin: 'Әкімші',
  membershipRole__basicMember: 'Мүше',
  membershipRole__guestMember: 'Қонақ',
  organizationList: {
    action__createOrganization: 'Ұйым құру',
    action__invitationAccept: 'Қосылу',
    action__suggestionsAccept: 'Қосылу сұрауы',
    createOrganization: 'Ұйым құру',
    invitationAcceptedLabel: 'Қосылды',
    subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
    suggestionsAcceptedLabel: 'Растауды күтуде',
    title: 'Есептік жазбаны таңдаңыз',
    titleWithoutPersonal: 'Ұйымды таңдаңыз',
  },
  organizationProfile: {
    apiKeysPage: {
      title: undefined,
    },
    badge__automaticInvitation: 'Автошақырулар',
    badge__automaticSuggestion: 'Автоұсыныстар',
    badge__manualInvitation: 'Автоқосылу жоқ',
    badge__unverified: 'Расталмаған',
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentMethodsSection: {
        actionLabel__default: 'Әдепкі ету',
        actionLabel__remove: 'Жою',
        add: 'Жаңа төлем әдісін қосу',
        addSubtitle: 'Есептік жазбаңызға жаңа төлем әдісін қосыңыз.',
        cancelButton: 'Болдырмау',
        formButtonPrimary__add: 'Төлем әдісін қосу',
        formButtonPrimary__pay: '{{amount}} төлеу',
        payWithTestCardButton: undefined,
        removeMethod: {
          messageLine1: '{{identifier}} есептік жазбадан жойылады.',
          messageLine2: 'Бұл төлем әдісін қолдана алмайсыз және оған тәуелді жазылымдар жұмыс істемейді.',
          successMessage: '{{paymentMethod}} жойылды.',
          title: 'Төлем әдісін жою',
        },
        title: 'Қолжетімді опциялар',
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: 'Жоспарлар',
        headerTitle__statements: 'Шот-фактуралар',
        headerTitle__subscriptions: 'Жазылымдар',
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__manageSubscription: undefined,
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: 'Басқару',
      },
      switchPlansSection: {
        title: undefined,
      },
      title: 'Төлемдер мен есеп айырысу',
    },
    createDomainPage: {
      subtitle:
        'Ұйымға автоқосылу үшін доменді қосыңыз. Осы домендегі электрондық поштасы бар пайдаланушылар автоматты түрде қосыла алады.',
      title: 'Домен қосу',
    },
    invitePage: {
      detailsTitle__inviteFailed: 'Келесі электрондық пошталарға шақыру жіберілмеді: {{email_addresses}}.',
      formButtonPrimary__continue: 'Шақыруларды жіберу',
      selectDropdown__role: 'Рөлді таңдау',
      subtitle: 'Бірнеше электрондық поштаны енгізіңіз немесе қойыңыз.',
      successMessage: 'Шақырулар сәтті жіберілді',
      title: 'Жаңа мүшелерді шақыру',
    },
    membersPage: {
      action__invite: 'Шақыру',
      action__search: 'Іздеу',
      activeMembersTab: {
        menuAction__remove: 'Мүшені жою',
        tableHeader__actions: 'Әрекеттер',
        tableHeader__joined: 'Қосылды',
        tableHeader__role: 'Рөл',
        tableHeader__user: 'Пайдаланушы',
      },
      alerts: {
        roleSetMigrationInProgress: {
          subtitle: 'Қолжетімді рөлдерді жаңартып жатырмыз. Бұл аяқталғаннан кейін рөлдерді қайта жаңарта аласыз.',
          title: 'Рөлдер уақытша құлыпталған',
        },
      },
      detailsTitle__emptyRow: 'Көрсету үшін мүшелер жоқ',
      invitationsTab: {
        autoInvitations: {
          headerSubtitle: 'Электрондық пошта доменін қосып, пайдаланушыларды автошақыру арқылы ұйымға қосыңыз.',
          headerTitle: 'Автошақырулар',
          primaryButton: 'Расталған домендерді басқару',
        },
        table__emptyRow: 'Көрсету үшін шақырулар жоқ',
      },
      invitedMembersTab: {
        menuAction__revoke: 'Шақыруды жою',
        tableHeader__invited: 'Шақырылды',
      },
      requestsTab: {
        autoSuggestions: {
          headerSubtitle: 'Домен бойынша тіркелген пайдаланушылар ұйымыңызға қосылу сұрауын көре алады.',
          headerTitle: 'Автоұсыныстар',
          primaryButton: 'Расталған домендерді басқару',
        },
        menuAction__approve: 'Қабылдау',
        menuAction__reject: 'Қабылдамау',
        tableHeader__requested: 'Қосылу сұралды',
        table__emptyRow: 'Көрсету үшін сұраулар жоқ',
      },
      start: {
        headerTitle__invitations: 'Шақырулар',
        headerTitle__members: 'Мүшелер',
        headerTitle__requests: 'Сұраулар',
      },
    },
    navbar: {
      apiKeys: undefined,
      billing: 'Төлемдер',
      description: 'Ұйымыңызды басқарыңыз.',
      general: 'Жалпы',
      members: 'Мүшелер',
      title: 'Ұйым',
    },
    plansPage: {
      alerts: {
        noPermissionsToManageBilling: undefined,
      },
      title: undefined,
    },
    profilePage: {
      dangerSection: {
        deleteOrganization: {
          actionDescription: 'Жалғастыру үшін "{{organizationName}}" деп енгізіңіз.',
          messageLine1: 'Бұл ұйымды жоюға сенімдісіз бе?',
          messageLine2: 'Бұл әрекет қайтымсыз және қалпына келтірілмейді.',
          successMessage: 'Ұйым жойылды.',
          title: 'Ұйымды жою',
        },
        leaveOrganization: {
          actionDescription: 'Жалғастыру үшін "{{organizationName}}" деп енгізіңіз.',
          messageLine1: 'Бұл ұйымнан шығуға сенімдісіз бе? Ұйымға және қосымшаларға қол жеткізе алмайсыз.',
          messageLine2: 'Бұл әрекет қайтымсыз.',
          successMessage: 'Сіз ұйымнан шықтыңыз.',
          title: 'Ұйымнан шығу',
        },
        title: 'Қауіпті',
      },
      domainSection: {
        menuAction__manage: 'Басқару',
        menuAction__remove: 'Жою',
        menuAction__verify: 'Растау',
        primaryButton: 'Домен қосу',
        subtitle: 'Расталған домен арқылы пайдаланушыларды автоқосылуын реттеңіз.',
        title: 'Расталған домендер',
      },
      successMessage: 'Ұйым жаңартылды.',
      title: 'Профильді жаңарту',
    },
    removeDomainPage: {
      messageLine1: '{{domain}} домені жойылады.',
      messageLine2: 'Пайдаланушылар автоқосыла алмайды.',
      successMessage: '{{domain}} жойылды.',
      title: 'Доменді жою',
    },
    start: {
      headerTitle__general: 'Жалпы',
      headerTitle__members: 'Мүшелер',
      profileSection: {
        primaryButton: 'Профильді жаңарту',
        title: 'Ұйым профилі',
        uploadAction__title: 'Логотип',
      },
    },
    verifiedDomainPage: {
      dangerTab: {
        calloutInfoLabel: 'Доменді жою шақырылған пайдаланушыларға әсер етеді.',
        removeDomainActionLabel__remove: 'Доменді жою',
        removeDomainSubtitle: 'Доменді расталған тізімнен алып тастау',
        removeDomainTitle: 'Доменді жою',
      },
      enrollmentTab: {
        automaticInvitationOption__description: 'Пайдаланушылар тіркелген кезде автошақырылады.',
        automaticInvitationOption__label: 'Автошақырулар',
        automaticSuggestionOption__description: 'Пайдаланушыларға ұсыныс жіберіледі, бірақ әкімші растауы керек.',
        automaticSuggestionOption__label: 'Автоұсыныстар',
        calloutInfoLabel: 'Тіркеу режимі жаңа пайдаланушыларға ғана әсер етеді.',
        calloutInvitationCountLabel: 'Күтудегі шақырулар: {{count}}',
        calloutSuggestionCountLabel: 'Күтудегі ұсыныстар: {{count}}',
        manualInvitationOption__description: 'Пайдаланушылар тек қолмен шақырылады.',
        manualInvitationOption__label: 'Автотіркеу жоқ',
        subtitle: 'Домен арқылы қосылу әдісін таңдаңыз.',
      },
      start: {
        headerTitle__danger: 'Қауіпті',
        headerTitle__enrollment: 'Тіркеу опциялары',
      },
      subtitle: '{{domain}} домені расталды. Тіркеу режимін таңдаңыз.',
      title: '{{domain}} жаңарту',
    },
    verifyDomainPage: {
      formSubtitle: 'Электрондық поштаңызға жіберілген растау кодын енгізіңіз',
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: '{{domainName}} доменін электрондық пошта арқылы растау қажет.',
      subtitleVerificationCodeScreen: '{{emailAddress}} жіберілген растау кодын енгізіңіз.',
      title: 'Доменді растау',
    },
  },
  organizationSwitcher: {
    action__closeOrganizationSwitcher: undefined,
    action__createOrganization: 'Ұйым құру',
    action__invitationAccept: 'Қосылу',
    action__manageOrganization: 'Басқару',
    action__openOrganizationSwitcher: undefined,
    action__suggestionsAccept: 'Қосылу сұрауы',
    notSelected: 'Ұйым таңдалмады',
    personalWorkspace: 'Жеке есептік жазба',
    suggestionsAcceptedLabel: 'Растауды күтуде',
  },
  paginationButton__next: 'Келесі',
  paginationButton__previous: 'Алдыңғы',
  paginationRowText__displaying: 'Көрсетілуде',
  paginationRowText__of: '/',
  reverification: {
    alternativeMethods: {
      actionLink: 'Көмек алу',
      actionText: 'Бұл опциялар жоқ па?',
      blockButton__backupCode: 'Сақтық кодын қолдану',
      blockButton__emailCode: '{{identifier}} электрондық поштасына код жіберу',
      blockButton__passkey: 'Passkey қолдану',
      blockButton__password: 'Құпия сөзбен жалғастыру',
      blockButton__phoneCode: '{{identifier}} нөміріне SMS жіберу',
      blockButton__totp: 'Аутентификатор қолдану',
      getHelp: {
        blockButton__emailSupport: 'Қолдау қызметіне хабарласу',
        content: 'Есептік жазбаны растауда қиындық туындаса, бізге хабарласыңыз.',
        title: 'Көмек алу',
      },
      subtitle: 'Растау әдісін өзгерту',
      title: 'Басқа әдісті қолдану',
    },
    backupCodeMfa: {
      subtitle: 'Екі қадамды растау кезінде алынған сақтық кодын енгізіңіз',
      title: 'Сақтық кодын енгізіңіз',
    },
    emailCode: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Жалғастыру үшін электрондық поштаңызға жіберілген кодты енгізіңіз',
      title: 'Растау қажет',
    },
    noAvailableMethods: {
      message: 'Растау мүмкін емес. Ешбір аутентификация әдісі қосылмаған.',
      subtitle: 'Қате орын алды',
      title: 'Есептік жазбаны растау мүмкін емес',
    },
    passkey: {
      blockButton__passkey: 'Құпия кілт қолдану',
      subtitle:
        'Құпия кілт арқылы сіздің тұлғаңыз расталады. Құрылғыңыз саусақ ізі, бет бейнесі немесе экран құлыптамасын сұрауы мүмкін.',
      title: 'Құпия кілт қолдану',
    },
    password: {
      actionLink: 'Басқа әдісті қолдану',
      subtitle: 'Жалғастыру үшін құпия сөзді енгізіңіз',
      title: 'Растау қажет',
    },
    phoneCode: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Жалғастыру үшін телефонға жіберілген кодты енгізіңіз',
      title: 'Растау қажет',
    },
    phoneCodeMfa: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Жалғастыру үшін телефонға жіберілген кодты енгізіңіз',
      title: 'Растау қажет',
    },
    totpMfa: {
      formTitle: 'Растау коды',
      subtitle: 'Аутентификатор қолданбасындағы кодты енгізіңіз',
      title: 'Растау қажет',
    },
  },
  signIn: {
    accountSwitcher: {
      action__addAccount: 'Есептік жазба қосу',
      action__signOutAll: 'Барлық есептік жазбалардан шығу',
      subtitle: 'Жалғастыратын есептік жазбаны таңдаңыз.',
      title: 'Есептік жазбаны таңдау',
    },
    alternativeMethods: {
      actionLink: 'Көмек алу',
      actionText: 'Басқа опциялар жоқ па?',
      blockButton__backupCode: 'Сақтық кодын қолдану',
      blockButton__emailCode: '{{identifier}} электрондық поштасына код жіберу',
      blockButton__emailLink: '{{identifier}} электрондық поштасына сілтеме жіберу',
      blockButton__passkey: 'Құпия кілт арқылы кіру',
      blockButton__password: 'Құпия сөзбен кіру',
      blockButton__phoneCode: '{{identifier}} нөміріне SMS жіберу',
      blockButton__totp: 'Аутентификатор қолдану',
      getHelp: {
        blockButton__emailSupport: 'Қолдау қызметіне хабарласу',
        content: 'Кіруде қиындық туындаса, бізге хабарласыңыз.',
        title: 'Көмек алу',
      },
      subtitle: 'Кіру әдісін өзгерту',
      title: 'Басқа әдісті қолдану',
    },
    alternativePhoneCodeProvider: {
      formTitle: undefined,
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    backupCodeMfa: {
      subtitle: 'Екі қадамды растау кезінде алынған сақтық кодын енгізіңіз',
      title: 'Сақтық кодын енгізіңіз',
    },
    emailCode: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
      title: 'Электрондық поштаңызды тексеріңіз',
    },
    emailCodeMfa: {
      formTitle: 'Электрондық поштаңызды тексеріңіз',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
      title: 'Электрондық поштаңызды тексеріңіз',
    },
    emailLink: {
      clientMismatch: {
        subtitle: 'Бастапқы құрылғыда растау сілтемесін ашыңыз.',
        title: 'Сілтеме осы құрылғыға жарамсыз',
      },
      expired: {
        subtitle: 'Жалғастыру үшін бастапқы бетке оралыңыз.',
        title: 'Растау сілтемесінің мерзімі бітті',
      },
      failed: {
        subtitle: 'Жалғастыру үшін бастапқы бетке оралыңыз.',
        title: 'Растау сілтемесі жарамсыз',
      },
      formSubtitle: 'Электрондық поштаңызға жіберілген сілтемені қолданыңыз',
      formTitle: 'Растау сілтемесі',
      loading: {
        subtitle: 'Сіз бағытталасыз...',
        title: 'Кіру процесі...',
      },
      resendButton: 'Сілтеме алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
      title: 'Электрондық поштаңызды тексеріңіз',
      unusedTab: {
        title: 'Бұл бетті жауып қойуға болады',
      },
      verified: {
        subtitle: 'Сіз сәтті кірдіңіз',
        title: 'Сәтті кірдіңіз',
      },
      verifiedSwitchTab: {
        subtitle: 'Жалғастыру үшін бастапқы бетке оралыңыз',
        subtitleNewTab: 'Жалғастыру үшін жаңа бетке оралыңыз',
        titleNewTab: 'Басқа бетте кірдіңіз',
      },
    },
    emailLinkMfa: {
      formSubtitle: 'Электрондық поштаңызға жіберілген растау сілтемесін пайдаланыңыз',
      resendButton: 'Сілтеме алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қосымшасына жалғастыру үшін',
      title: 'Электрондық поштаңызды тексеріңіз',
    },
    enterpriseConnections: {
      subtitle: undefined,
      title: undefined,
    },
    forgotPassword: {
      formTitle: 'Құпия сөзді қалпына келтіру коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Құпия сөзді қалпына келтіру үшін',
      subtitle_email: 'Алдымен электрондық поштаңызға жіберілген кодты енгізіңіз',
      subtitle_phone: 'Алдымен телефонға жіберілген кодты енгізіңіз',
      title: 'Құпия сөзді қалпына келтіру',
    },
    forgotPasswordAlternativeMethods: {
      blockButton__resetPassword: 'Құпия сөзді қалпына келтіру',
      label__alternativeMethods: 'Немесе басқа әдісті қолданыңыз',
      title: 'Құпия сөзді ұмыттыңыз ба?',
    },
    newDeviceVerificationNotice:
      'Сіз жаңа құрылғыдан кірудесіз. Біз сіздің есептік жазбаңызды қауіпсіз сақтау үшін растау сұраймыз.',
    noAvailableMethods: {
      message: 'Кіру мүмкін емес. Аутентификация әдісі қолжетімсіз.',
      subtitle: 'Қате орын алды',
      title: 'Кіру мүмкін емес',
    },
    passkey: {
      subtitle:
        'Құпия кілт арқылы тұлғаңыз расталады. Құрылғыңыз саусақ ізі, бет бейнесі немесе экран құлыптамасын сұрауы мүмкін.',
      title: 'Құпия кілт қолдану',
    },
    password: {
      actionLink: 'Басқа әдісті қолдану',
      subtitle: 'Есептік жазбаңыздың құпия сөзін енгізіңіз',
      title: 'Құпия сөзді енгізіңіз',
    },
    passwordCompromised: {
      title: undefined,
    },
    passwordPwned: {
      title: 'Құпия сөз қауіпті',
    },
    passwordUntrusted: {
      title: undefined,
    },
    phoneCode: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
      title: 'Телефонды тексеріңіз',
    },
    phoneCodeMfa: {
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Жалғастыру үшін телефонға жіберілген кодты енгізіңіз',
      title: 'Телефонды тексеріңіз',
    },
    resetPassword: {
      formButtonPrimary: 'Құпия сөзді өзгерту',
      requiredMessage: 'Қауіпсіздік себептерімен құпия сөзді өзгерту қажет.',
      successMessage: 'Құпия сөз сәтті өзгертілді. Кіру үшін күтіңіз.',
      title: 'Жаңа құпия сөзді орнату',
    },
    resetPasswordMfa: {
      detailsLabel: 'Құпия сөзді өзгерту үшін тұлғаңызды растау қажет.',
    },
    start: {
      actionLink: 'Тіркелу',
      actionLink__join_waitlist: 'Күту тізіміне қосылу',
      actionLink__use_email: 'Электрондық поштаны қолдану',
      actionLink__use_email_username: 'Электрондық пошта немесе пайдаланушы аты',
      actionLink__use_passkey: 'Құпия кілт қолдану',
      actionLink__use_phone: 'Телефон нөмірін қолдану',
      actionLink__use_username: 'Пайдаланушы атын қолдану',
      actionText: 'Есептік жазбаңыз жоқ па?',
      actionText__join_waitlist: 'Ерте қол жеткізгіңіз келе ме?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Қош келдіңіз! Жалғастыру үшін кіріңіз',
      subtitleCombined: undefined,
      title: '{{applicationName}} қолдану үшін кіріңіз',
      titleCombined: '{{applicationName}} қолдануды жалғастыру',
    },
    totpMfa: {
      formTitle: 'Растау коды',
      subtitle: 'Аутентификатор қолданбасындағы кодты енгізіңіз',
      title: 'Екі қадамды растау',
    },
    web3Solana: {
      subtitle: 'Кіру үшін төменде әмиянды таңдаңыз',
      title: 'Solana арқылы кіру',
    },
  },
  signInEnterPasswordTitle: 'Құпия сөзді енгізіңіз',
  signUp: {
    alternativePhoneCodeProvider: {
      resendButton: undefined,
      subtitle: undefined,
      title: undefined,
    },
    continue: {
      actionLink: 'Кіру',
      actionText: 'Есептік жазбаңыз бар ма?',
      subtitle: 'Қалған ақпаратты толтырыңыз.',
      title: 'Жетіспейтін өрістерді толтыру',
    },
    emailCode: {
      formSubtitle: 'Электрондық поштаңызға жіберілген растау кодын енгізіңіз',
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Электрондық поштаңызды растаңыз',
      title: 'Электрондық поштаны растау',
    },
    emailLink: {
      clientMismatch: {
        subtitle: 'Растау сілтемесін бастапқы құрылғыда ашыңыз.',
        title: 'Сілтеме осы құрылғыға жарамсыз',
      },
      formSubtitle: 'Электрондық поштаңызға жіберілген сілтемені қолданыңыз',
      formTitle: 'Растау сілтемесі',
      loading: {
        title: 'Тіркелу...',
      },
      resendButton: 'Сілтеме алмадыңыз ба? Қайта жіберу',
      subtitle: '{{applicationName}} қолдануды жалғастыру үшін',
      title: 'Электрондық поштаңызды растау',
      verified: {
        title: 'Сәтті тіркелдіңіз',
      },
      verifiedSwitchTab: {
        subtitle: 'Жалғастыру үшін жаңа бетке оралыңыз',
        subtitleNewTab: 'Жалғастыру үшін алдыңғы бетке оралыңыз',
        title: 'Электрондық пошта расталды',
      },
    },
    enterpriseConnections: {
      subtitle: undefined,
      title: undefined,
    },
    legalConsent: {
      checkbox: {
        label__onlyPrivacyPolicy: '{{ privacyPolicyLink || link("Құпиялылық саясаты") }} қабылдаймын',
        label__onlyTermsOfService: '{{ termsOfServiceLink || link("Қызмет көрсету шарттары") }} қабылдаймын',
        label__termsOfServiceAndPrivacyPolicy:
          '{{ termsOfServiceLink || link("Қызмет көрсету шарттары") }} және {{ privacyPolicyLink || link("Құпиялылық саясаты") }} қабылдаймын',
      },
      continue: {
        subtitle: 'Жалғастыру үшін шарттарды қабылдаңыз',
        title: 'Заңды келісім',
      },
    },
    phoneCode: {
      formSubtitle: 'Телефон нөміріңізге жіберілген растау кодын енгізіңіз',
      formTitle: 'Растау коды',
      resendButton: 'Код алмадыңыз ба? Қайта жіберу',
      subtitle: 'Телефон нөміріңізді растаңыз',
      title: 'Телефон нөмірін растау',
    },
    restrictedAccess: {
      actionLink: 'Кіру',
      actionText: 'Есептік жазбаңыз бар ма?',
      blockButton__emailSupport: 'Қолдау қызметіне хабарласу',
      blockButton__joinWaitlist: 'Күту тізіміне қосылу',
      subtitle: 'Тіркеу уақытша өшірілген. Қолдау қызметіне хабарласыңыз.',
      subtitleWaitlist: 'Тіркеу уақытша өшірілген. Күту тізіміне қосылыңыз.',
      title: 'Қол жеткізу шектеулі',
    },
    start: {
      actionLink: 'Кіру',
      actionLink__use_email: 'Электрондық поштаны қолдану',
      actionLink__use_phone: 'Телефон нөмірін қолдану',
      actionText: 'Есептік жазбаңыз бар ма?',
      alternativePhoneCodeProvider: {
        actionLink: undefined,
        label: undefined,
        subtitle: undefined,
        title: undefined,
      },
      subtitle: 'Қош келдіңіз! Тіркелу үшін ақпаратты толтырыңыз.',
      subtitleCombined: 'Қош келдіңіз! Тіркелу үшін ақпаратты толтырыңыз.',
      title: 'Есептік жазбаны құру',
      titleCombined: 'Есептік жазбаны құру',
    },
    web3Solana: {
      subtitle: 'Тіркелу үшін төменде әмиянды таңдаңыз',
      title: 'Solana арқылы тіркелу',
    },
  },
  socialButtonsBlockButton: '{{provider|titleize}} арқылы жалғастыру',
  socialButtonsBlockButtonManyInView: '{{provider|titleize}}',
  taskChooseOrganization: {
    alerts: {
      organizationAlreadyExists:
        'Анықталған компания атауы ({{organizationName}}) және {{organizationDomain}} үшін ұйым бұрыннан бар. Шақыру арқылы қосылыңыз.',
    },
    chooseOrganization: {
      action__createOrganization: 'Жаңа ұйым құру',
      action__invitationAccept: 'Қосылу',
      action__suggestionsAccept: 'Қосылуды сұрау',
      subtitle: 'Мәні бар ұйымға қосылыңыз немесе жаңасын құрыңыз',
      subtitle__createOrganizationDisabled: 'Бар ұйымға қосылыңыз',
      suggestionsAcceptedLabel: 'Мақұлдау күтілуде',
      title: 'Ұйым таңдаңыз',
    },
    createOrganization: {
      formButtonReset: 'Болдырмау',
      formButtonSubmit: 'Жалғастыру',
      formFieldInputPlaceholder__name: 'Менің ұйымым',
      formFieldInputPlaceholder__slug: 'menin-uiyym',
      formFieldLabel__name: 'Атауы',
      formFieldLabel__slug: 'Slug',
      subtitle: 'Жалғастыру үшін ұйымыңыздың мәліметтерін енгізіңіз',
      title: 'Ұйымыңызды баптаңыз',
    },
    organizationCreationDisabled: {
      subtitle: 'Шақыру алу үшін ұйымыңыздың әкімшісіне хабарласыңыз.',
      title: 'Сіз ұйымға тиесілі болуыңыз керек',
    },
    signOut: {
      actionLink: 'Шығу',
      actionText: '{{identifier}} ретінде кірді',
    },
  },
  taskResetPassword: {
    formButtonPrimary: undefined,
    signOut: {
      actionLink: undefined,
      actionText: undefined,
    },
    subtitle: undefined,
    title: undefined,
  },
  taskSetupMfa: {
    badge: undefined,
    signOut: {
      actionLink: undefined,
      actionText: undefined,
    },
    smsCode: {
      addPhone: {
        formButtonPrimary: undefined,
        infoText: undefined,
      },
      addPhoneNumber: undefined,
      cancel: undefined,
      subtitle: undefined,
      success: {
        finishButton: undefined,
        message1: undefined,
        message2: undefined,
        title: undefined,
      },
      title: undefined,
      verifyPhone: {
        formButtonPrimary: undefined,
        formTitle: undefined,
        resendButton: undefined,
        subtitle: undefined,
        title: undefined,
      },
    },
    start: {
      methodSelection: {
        phoneCode: undefined,
        totp: undefined,
      },
      subtitle: undefined,
      title: undefined,
    },
    totpCode: {
      addAuthenticatorApp: {
        buttonAbleToScan__nonPrimary: undefined,
        buttonUnableToScan__nonPrimary: undefined,
        formButtonPrimary: undefined,
        formButtonReset: undefined,
        infoText__ableToScan: undefined,
        infoText__unableToScan: undefined,
        inputLabel__unableToScan1: undefined,
      },
      success: {
        finishButton: undefined,
        message1: undefined,
        message2: undefined,
        title: undefined,
      },
      title: undefined,
      verifyTotp: {
        formButtonPrimary: undefined,
        formButtonReset: undefined,
        formTitle: undefined,
        subtitle: undefined,
        title: undefined,
      },
    },
  },
  unstable__errors: {
    already_a_member_in_organization: '{{email}} ұйымға қазірдің өзінде қосылған.',
    avatar_file_size_exceeded: 'Файл өлшемі 10 МБ шегінен асып кетті. Кішірек файлды таңдаңыз.',
    avatar_file_type_invalid: 'Файл түрі қолдау көрсетілмейді. JPG, PNG, GIF немесе WEBP суретін жүктеңіз.',
    captcha_invalid: 'Қауіпсіздік тексерілуі сәтсіз аяқталды. Браузерді өзгерту немесе кеңейтулерді өшіруге тырысыңыз.',
    captcha_unavailable: 'Бот тексерілуі сәтсіз аяқталды. Бетті жаңартып немесе қолдау қызметіне хабарласыңыз.',
    form_code_incorrect: undefined,
    form_email_address_blocked:
      'Уақытша электрондық пошта қызметтері қолдау көрсетілмейді. Есептік жазбаны жасау үшін кәдімгі электрондық пошта мекенжайыңызды пайдаланыңыз.',
    form_identifier_exists__email_address: 'Бұл электрондық пошта тіркелген. Басқасын қолданыңыз.',
    form_identifier_exists__phone_number: 'Бұл телефон нөмірі тіркелген. Басқасын қолданыңыз.',
    form_identifier_exists__username: 'Бұл пайдаланушы аты тіркелген. Басқасын қолданыңыз.',
    form_identifier_not_found: 'Есептік жазба табылмады. Дұрыстығын тексеріңіз.',
    form_new_password_matches_current: undefined,
    form_param_format_invalid: 'Енгізілген мән жарамсыз пішімде.',
    form_param_format_invalid__email_address: 'Электрондық пошта жарамсыз.',
    form_param_format_invalid__phone_number: 'Телефон нөмірі жарамсыз.',
    form_param_max_length_exceeded__first_name: 'Аты 256 таңбадан аспауы керек.',
    form_param_max_length_exceeded__last_name: 'Тегі 256 таңбадан аспауы керек.',
    form_param_max_length_exceeded__name: 'Атауы 256 таңбадан аспауы керек.',
    form_param_nil: 'Бұл өріс міндетті.',
    form_param_type_invalid: undefined,
    form_param_type_invalid__email_address: undefined,
    form_param_type_invalid__phone_number: undefined,
    form_param_value_invalid: 'Енгізілген мән жарамсыз.',
    form_password_compromised__sign_in: undefined,
    form_password_incorrect: 'Құпия сөз қате.',
    form_password_length_too_short: 'Құпия сөз тым қысқа. Кемінде 8 таңба болуы керек.',
    form_password_not_strong_enough: 'Құпия сөз әлсіз.',
    form_password_or_identifier_incorrect:
      'Құпия сөз немесе электрондық пошта мекенжайы дұрыс емес. Қайталап көріңіз немесе басқа әдісті пайдаланыңыз.',
    form_password_pwned: 'Бұл құпия сөз қауіпсіздік бұзылуынан табылды. Басқа құпия сөзді қолданыңыз.',
    form_password_pwned__sign_in: 'Бұл құпия сөз қауіпсіз емес. Құпия сөзді өзгертуге болады.',
    form_password_size_in_bytes_exceeded:
      'Құпия сөзде тым көп байт бар. Оны қысқартыңыз немесе арнайы таңбаларды алып тастаңыз.',
    form_password_untrusted__sign_in: undefined,
    form_password_validation_failed: 'Құпия сөз қате',
    form_username_invalid_character:
      'Пайдаланушы атында жарамсыз таңбалар бар. Тек әріптер, сандар және астыңғы сызықшаларды қолданыңыз.',
    form_username_invalid_length: 'Пайдаланушы аты {{min_length}} пен {{max_length}} арасында болуы керек.',
    form_username_needs_non_number_char: 'Пайдаланушы атыңызда кемінде бір санды емес таңба болуы керек.',
    identification_deletion_failed: 'Соңғы идентификацияны жою мүмкін емес.',
    not_allowed_access: 'Бұл бетке қол жеткізуге рұқсат жоқ. Қате болса, қолдау қызметіне хабарласыңыз.',
    organization_domain_blocked: 'Бұл электрондық пошта домені бұғатталған. Басқасын қолданыңыз.',
    organization_domain_common: 'Бұл жалпы электрондық пошта домені. Басқасын қолданыңыз.',
    organization_domain_exists_for_enterprise_connection: 'Бұл домен ұйымыңыздың SSO үшін қолданылады.',
    organization_membership_quota_exceeded: 'Ұйым мүшеліктерінің шектеуіне жеттіңіз.',
    organization_minimum_permissions_needed: 'Ұйымда кемінде бір әкімші болуы керек.',
    organization_not_found_or_unauthorized: undefined,
    organization_not_found_or_unauthorized_with_create_organization_disabled: undefined,
    passkey_already_exists: 'Бұл құрылғыда passkey тіркелген.',
    passkey_not_supported: 'Бұл құрылғыда passkey қолдауы жоқ.',
    passkey_pa_not_supported: 'Тіркеу үшін платформа аутентификаторы қажет.',
    passkey_registration_cancelled: 'Passkey тіркеуі тоқтатылды немесе мерзімі бітті.',
    passkey_retrieval_cancelled: 'Passkey тексеруі тоқтатылды немесе мерзімі бітті.',
    passwordComplexity: {
      maximumLength: '{{length}} таңбадан кем',
      minimumLength: '{{length}} таңбадан көп',
      requireLowercase: 'кіші әріп',
      requireNumbers: 'сан',
      requireSpecialCharacter: 'арнайы таңба',
      requireUppercase: 'бас әріп',
      sentencePrefix: 'Құпия сөзде болуы керек:',
    },
    phone_number_exists: 'Бұл телефон нөмірі тіркелген. Басқасын қолданыңыз.',
    session_exists: undefined,
    web3_missing_identifier: 'Web3 Wallet кеңейтуі табылмады. Орнатыңыз.',
    web3_signature_request_rejected: 'Сіз қолтаңба сұрауын қабылдамадыңыз. Жалғастыру үшін қайтадан көріңіз.',
    web3_solana_signature_generation_failed:
      'Қолтаңбаны жасау кезінде қате орын алды. Жалғастыру үшін қайтадан көріңіз.',
    zxcvbn: {
      couldBeStronger: 'Құпия сөз әлсіз. Таңбалар санын көбейтіңіз.',
      goodPassword: 'Құпия сөз талаптарға сай.',
      notEnough: 'Құпия сөз әлсіз.',
      suggestions: {
        allUppercase: 'Кейбір әріптерді бас әріппен жазыңыз.',
        anotherWord: 'Сирек сөздерді қосыңыз.',
        associatedYears: 'Жеке жылдардан аулақ болыңыз.',
        capitalization: 'Бірінші әріптен басқаларын да бас әріппен жазыңыз.',
        dates: 'Жеке күндер мен жылдардан аулақ болыңыз.',
        l33t: '"@" сияқты алмастырулардан аулақ болыңыз.',
        longerKeyboardPattern: 'Ұзын әріптер тізбегін қолданыңыз.',
        noNeed: 'Құпия сөзді арнайы таңбаларсыз жасауға болады.',
        pwned: 'Басқа жерде қолдансаңыз, өзгертіңіз.',
        recentYears: 'Соңғы жылдардан аулақ болыңыз.',
        repeated: 'Қайталанған сөздер мен таңбалардан аулақ болыңыз.',
        reverseWords: 'Кері сөздерден аулақ болыңыз.',
        sequences: 'Жиі кездесетін тізбектерден аулақ болыңыз.',
        useWords: 'Бірнеше сөзді қолданыңыз, бірақ жалпы сөз тіркестерінен аулақ болыңыз.',
      },
      warnings: {
        common: 'Бұл жиі қолданылатын құпия сөз.',
        commonNames: 'Жалпы атаулар оңай болжауға болады.',
        dates: 'Күндер оңай болжауға болады.',
        extendedRepeat: 'Қайталанған әріптер тізбегі оңай болжауға болады.',
        keyPattern: 'Қысқа перне тізбегі оңай болжауға болады.',
        namesByThemselves: 'Жеке атаулар оңай болжауға болады.',
        pwned: 'Құпия сөз Интернеттегі деректердің бұзылуынан табылды.',
        recentYears: 'Соңғы жылдар оңай болжауға болады.',
        sequences: 'Жиі кездесетін тізбектер оңай болжауға болады.',
        similarToCommon: 'Бұл жиі қолданылатын құпия сөзге ұқсас.',
        simpleRepeat: 'Қайталанған әріптер оңай болжауға болады.',
        straightRow: 'Тікелей пернелер қатары оңай болжауға болады.',
        topHundred: 'Бұл жиі қолданылатын құпия сөз.',
        topTen: 'Бұл өте жиі қолданылатын құпия сөз.',
        userInputs: 'Жеке немесе бетке қатысты деректер болмауы керек.',
        wordByItself: 'Жалғыз сөздер оңай болжауға болады.',
      },
    },
  },
  userButton: {
    action__addAccount: 'Есептік жазба қосу',
    action__closeUserMenu: undefined,
    action__manageAccount: 'Есептік жазбаны басқару',
    action__openUserMenu: undefined,
    action__signOut: 'Шығу',
    action__signOutAll: 'Барлық есептік жазбалардан шығу',
  },
  userProfile: {
    apiKeysPage: {
      title: undefined,
    },
    backupCodePage: {
      actionLabel__copied: 'Көшірілді!',
      actionLabel__copy: 'Барлығын көшіру',
      actionLabel__download: '.txt жүктеу',
      actionLabel__print: 'Басып шығару',
      infoText1: 'Бұл есептік жазба үшін сақтық кодтары қосылады.',
      infoText2: 'Сақтық кодтарын қауіпсіз жерде сақтаңыз. Құрылғыға қол жеткізе алмасаңыз, оларды қолданыңыз.',
      subtitle__codelist: 'Оларды қауіпсіз сақтаңыз.',
      successMessage: 'Сақтық кодтары қосылды. Құрылғыға қол жеткізе алмасаңыз, олардың бірін қолданыңыз.',
      successSubtitle: 'Құрылғыға қол жеткізе алмасаңыз, сақтық кодтарын қолданыңыз.',
      title: 'Сақтық кодтарын қосу',
      title__codelist: 'Сақтық кодтары',
    },
    billingPage: {
      paymentHistorySection: {
        empty: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        tableHeader__status: undefined,
      },
      paymentMethodsSection: {
        actionLabel__default: 'Әдепкі ету',
        actionLabel__remove: 'Жою',
        add: 'Жаңа төлем әдісін қосу',
        addSubtitle: 'Есептік жазбаңызға жаңа төлем әдісін қосыңыз.',
        cancelButton: 'Болдырмау',
        formButtonPrimary__add: 'Төлем әдісін қосу',
        formButtonPrimary__pay: '{{amount}} төлеу',
        payWithTestCardButton: undefined,
        removeMethod: {
          messageLine1: '{{identifier}} есептік жазбадан жойылады.',
          messageLine2: 'Бұл төлем әдісін қолдана алмайсыз және оған тәуелді жазылымдар жұмыс істемейді.',
          successMessage: '{{paymentMethod}} жойылды.',
          title: 'Төлем әдісін жою',
        },
        title: 'Қолжетімді опциялар',
      },
      start: {
        headerTitle__payments: undefined,
        headerTitle__plans: 'Жоспарлар',
        headerTitle__statements: 'Шот-фактуралар',
        headerTitle__subscriptions: 'Жазылымдар',
      },
      statementsSection: {
        empty: undefined,
        itemCaption__paidForPlan: undefined,
        itemCaption__proratedCredit: undefined,
        itemCaption__subscribedAndPaidForPlan: undefined,
        notFound: undefined,
        tableHeader__amount: undefined,
        tableHeader__date: undefined,
        title: undefined,
        totalPaid: undefined,
      },
      subscriptionsListSection: {
        actionLabel__manageSubscription: undefined,
        actionLabel__newSubscription: undefined,
        actionLabel__switchPlan: undefined,
        tableHeader__edit: undefined,
        tableHeader__plan: undefined,
        tableHeader__startDate: undefined,
        title: undefined,
      },
      subscriptionsSection: {
        actionLabel__default: 'Басқару',
      },
      switchPlansSection: {
        title: undefined,
      },
      title: 'Төлемдер мен есеп айырысу',
    },
    connectedAccountPage: {
      formHint: 'Қосылатын провайдерді таңдаңыз.',
      formHint__noAccounts: 'Қолжетімді провайдерлер жоқ.',
      removeResource: {
        messageLine1: '{{identifier}} есептік жазбадан жойылады.',
        messageLine2: 'Бұл есептік жазбаны қолдана алмайсыз және тәуелді мүмкіндіктер жұмыс істемейді.',
        successMessage: '{{connectedAccount}} жойылды.',
        title: 'Қосылған есептік жазбаны жою',
      },
      socialButtonsBlockButton: '{{provider|titleize}}',
      successMessage: 'Провайдер есептік жазбаңызға қосылды',
      title: 'Қосылған есептік жазбаны қосу',
    },
    deletePage: {
      actionDescription: 'Жалғастыру үшін "Есептік жазбаны жою" деп енгізіңіз.',
      confirm: 'Есептік жазбаны жою',
      messageLine1:
        'Тіркелгіңізді жойғыңыз келетініне сенімдісіз бе? Кейбір байланысты деректер сақталуы мүмкін. Деректерді толық жою үшін қолдау қызметіне хабарласыңыз.',
      messageLine2: 'Бұл әрекет тұрақты және қайтымсыз.',
      title: 'Есептік жазбаны жою',
    },
    emailAddressPage: {
      emailCode: {
        formHint: 'Растау коды осы электрондық пошта мекенжайына жіберіледі.',
        formSubtitle: '{{identifier}} жіберілген растау кодын енгізіңіз',
        formTitle: 'Растау коды',
        resendButton: 'Код алмадыңыз ба? Қайта жіберу',
        successMessage: '{{identifier}} электрондық поштасы есептік жазбаңызға қосылды.',
      },
      emailLink: {
        formHint: 'Растау сілтемесі осы электрондық пошта мекенжайына жіберіледі.',
        formSubtitle: '{{identifier}} жіберілген электрондық хаттағы растау сілтемесін басыңыз',
        formTitle: 'Растау сілтемесі',
        resendButton: 'Сілтеме алмадыңыз ба? Қайта жіберу',
        successMessage: '{{identifier}} электрондық поштасы есептік жазбаңызға қосылды.',
      },
      enterpriseSSOLink: {
        formButton: 'Кіру үшін басыңыз',
        formSubtitle: '{{identifier}} арқылы кіруді аяқтаңыз',
      },
      formHint: 'Электрондық поштаны есептік жазбаға қоспас бұрын растау қажет.',
      removeResource: {
        messageLine1: '{{identifier}} есептік жазбадан жойылады.',
        messageLine2: 'Бұл электрондық пошта арқылы кіре алмайсыз.',
        successMessage: '{{emailAddress}} есептік жазбаңыздан жойылды.',
        title: 'Электрондық поштаны жою',
      },
      title: 'Электрондық поштаны қосу',
      verifyTitle: 'Электрондық поштаны растау',
    },
    formButtonPrimary__add: 'Қосу',
    formButtonPrimary__continue: 'Жалғастыру',
    formButtonPrimary__finish: 'Аяқтау',
    formButtonPrimary__remove: 'Жою',
    formButtonPrimary__save: 'Сақтау',
    formButtonReset: 'Болдырмау',
    mfaPage: {
      formHint: 'Қосылатын әдісті таңдаңыз.',
      title: 'Екі қадамды растауды қосу',
    },
    mfaPhoneCodePage: {
      backButton: 'Бар нөмірді қолдану',
      primaryButton__addPhoneNumber: 'Телефон нөмірін қосу',
      removeResource: {
        messageLine1: '{{identifier}} нөміріне кіру кезінде растау кодтары жіберілмейді.',
        messageLine2: 'Есептік жазбаның қауіпсіздігі төмендеуі мүмкін. Жалғастырасыз ба?',
        successMessage: '{{mfaPhoneCode}} үшін SMS коды арқылы екі қадамды растау өшірілді',
        title: 'Екі қадамды растауды өшіру',
      },
      subtitle__availablePhoneNumbers:
        'SMS коды арқылы екі қадамды растау үшін бар нөмірді таңдаңыз немесе жаңасын қосыңыз.',
      subtitle__unavailablePhoneNumbers:
        'SMS коды арқылы екі қадамды растау үшін қолжетімді нөмірлер жоқ, жаңа нөмір қосыңыз.',
      successMessage1: 'Кіру кезінде осы телефон нөміріне жіберілген растау кодын енгізу қажет болады.',
      successMessage2:
        'Сақтық кодтарын қауіпсіз жерге сақтаңыз. Аутентификация құрылғысына қол жеткізе алмасаңыз, сақтық кодтары арқылы кіре аласыз.',
      successTitle: 'SMS коды арқылы растау қосылды',
      title: 'SMS коды арқылы растауды қосу',
    },
    mfaTOTPPage: {
      authenticatorApp: {
        buttonAbleToScan__nonPrimary: 'Орнына QR кодын сканерлеу',
        buttonUnableToScan__nonPrimary: 'QR кодын сканерлей алмайсыз ба?',
        infoText__ableToScan: 'Аутентификатор қолданбасында жаңа кіру әдісін орнатып, төмендегі QR кодын сканерлеңіз.',
        infoText__unableToScan: 'Аутентификатор қолданбасында жаңа кіру әдісін орнатып, төмендегі Кілтті енгізіңіз.',
        inputLabel__unableToScan1:
          'Уақыт не Бір реттік құпия сөздер қосылғанын тексеріп, есептік жазбаны байланыстырыңыз.',
        inputLabel__unableToScan2: 'Аутентификаторыңыз TOTP URI қолдаса, толық URI мекенжайын да көшіре аласыз.',
      },
      removeResource: {
        messageLine1: 'Осы аутентификатордан растау кодтары енді талап етілмейді.',
        messageLine2: 'Есептік жазбаның қауіпсіздігі төмендеуі мүмкін. Жалғастырасыз ба?',
        successMessage: 'Аутентификатор арқылы екі қадамды растау өшірілді',
        title: 'Екі қадамды растауды өшіру',
      },
      successMessage:
        'Екі қадамды растау қосылды. Кіру кезінде аутентификатордан алынған растау кодын енгізу қажет болады.',
      title: 'Аутентификатор қолданбасын қосу',
      verifySubtitle: 'Аутентификаторыңыз жасаған растау кодын енгізіңіз',
      verifyTitle: 'Растау коды',
    },
    mobileButton__menu: 'Мәзір',
    navbar: {
      account: 'Профиль',
      apiKeys: undefined,
      billing: 'Төлемдер',
      description: 'Есептік жазба ақпаратын басқару.',
      security: 'Қауіпсіздік',
      title: 'Есептік жазба',
    },
    passkeyScreen: {
      removeResource: {
        messageLine1: '{{name}} есептік жазбадан жойылады.',
        title: 'Құпия кілтті жою',
      },
      subtitle__rename: 'Құпия кілт атауын өзгерту арқылы іздеуді жеңілдетуге болады.',
      title__rename: 'Құпия кілт атауын өзгерту',
    },
    passwordPage: {
      checkboxInfoText__signOutOfOtherSessions: 'Ескі құпия сөзді қолданған барлық басқа құрылғылардан шығу ұсынылады.',
      readonly: 'Кәсіпорын байланысы арқылы кіретін болғандықтан, құпия сөзді өзгерту мүмкін емес.',
      successMessage__set: 'Құпия сөз орнатылды.',
      successMessage__signOutOfOtherSessions: 'Барлық басқа құрылғылардан шықтыңыз.',
      successMessage__update: 'Құпия сөз жаңартылды.',
      title__set: 'Құпия сөзді орнату',
      title__update: 'Құпия сөзді жаңарту',
    },
    phoneNumberPage: {
      infoText: 'Растау коды осы телефон нөміріне SMS арқылы жіберіледі. SMS жіберу ақысы болуы мүмкін.',
      removeResource: {
        messageLine1: '{{identifier}} есептік жазбадан жойылады.',
        messageLine2: 'Бұл телефон нөмірі арқылы кіре алмайсыз.',
        successMessage: '{{phoneNumber}} жойылды.',
        title: 'Телефон нөмірін жою',
      },
      successMessage: '{{identifier}} есептік жазбаға қосылды.',
      title: 'Телефон нөмірін қосу',
      verifySubtitle: '{{identifier}} нөміріне жіберілген кодты енгізіңіз',
      verifyTitle: 'Телефон нөмірін растау',
    },
    plansPage: {
      title: undefined,
    },
    profilePage: {
      fileDropAreaHint: 'Ұсынылатын өлшемі 1:1, максимум 10MB.',
      imageFormDestructiveActionSubtitle: 'Жою',
      imageFormSubtitle: 'Жүктеу',
      imageFormTitle: 'Профиль суреті',
      readonly: 'Профиль ақпараты кәсіпорын байланысы арқылы берілген және өзгертілмейді.',
      successMessage: 'Профиль жаңартылды.',
      title: 'Профильді жаңарту',
    },
    start: {
      activeDevicesSection: {
        destructiveAction: 'Құрылғыдан шығу',
        title: 'Белсенді құрылғылар',
      },
      connectedAccountsSection: {
        actionLabel__connectionFailed: 'Қайта қосу',
        actionLabel__reauthorize: 'Қазір рұқсат беру',
        destructiveActionTitle: 'Жою',
        primaryButton: 'Есептік жазбаны қосу',
        subtitle__disconnected: 'Бұл есептік жазба ажыратылды.',
        subtitle__reauthorize: 'Рұқсаттар өзгерді. Функционалдық шектеулерден аулақ болу үшін қайта рұқсат беріңіз',
        title: 'Қосылған есептік жазбалар',
      },
      dangerSection: {
        deleteAccountButton: 'Есептік жазбаны жою',
        title: 'Есептік жазбаны жою',
      },
      emailAddressesSection: {
        destructiveAction: 'Электрондық поштаны жою',
        detailsAction__nonPrimary: 'Негізгі ретінде орнату',
        detailsAction__primary: 'Растауды аяқтау',
        detailsAction__unverified: 'Растау',
        primaryButton: 'Электрондық поштаны қосу',
        title: 'Электрондық пошталар',
      },
      enterpriseAccountsSection: {
        primaryButton: 'Есептік жазбаны қосу',
        title: 'Кәсіпорын есептік жазбалары',
      },
      headerTitle__account: 'Профиль мәліметтері',
      headerTitle__security: 'Қауіпсіздік',
      mfaSection: {
        backupCodes: {
          actionLabel__regenerate: 'Қайта жасау',
          headerTitle: 'Сақтық кодтары',
          subtitle__regenerate: 'Жаңа сақтық кодтарын алыңыз. Алдыңғы кодтар жойылады және қолданылмайды.',
          title__regenerate: 'Сақтық кодтарын қайта жасау',
        },
        phoneCode: {
          actionLabel__setDefault: 'Әдепкі ретінде орнату',
          destructiveActionLabel: 'Жою',
        },
        primaryButton: 'Екі қадамды растауды қосу',
        title: 'Екі қадамды растау',
        totp: {
          destructiveActionTitle: 'Жою',
          headerTitle: 'Аутентификатор қолданбасы',
        },
      },
      passkeysSection: {
        menuAction__destructive: 'Жою',
        menuAction__rename: 'Атауын өзгерту',
        primaryButton: 'Құпия кілтті қосу',
        title: 'Құпия кілттер',
      },
      passwordSection: {
        primaryButton__setPassword: 'Құпия сөзді орнату',
        primaryButton__updatePassword: 'Құпия сөзді жаңарту',
        title: 'Құпия сөз',
      },
      phoneNumbersSection: {
        destructiveAction: 'Телефон нөмірін жою',
        detailsAction__nonPrimary: 'Негізгі ретінде орнату',
        detailsAction__primary: 'Растауды аяқтау',
        detailsAction__unverified: 'Телефон нөмірін растау',
        primaryButton: 'Телефон нөмірін қосу',
        title: 'Телефон нөмірлері',
      },
      profileSection: {
        primaryButton: 'Профильді жаңарту',
        title: 'Профиль',
      },
      usernameSection: {
        primaryButton__setUsername: 'Пайдаланушы атын орнату',
        primaryButton__updateUsername: 'Пайдаланушы атын жаңарту',
        title: 'Пайдаланушы аты',
      },
      web3WalletsSection: {
        destructiveAction: 'Әптәпқалманы жою',
        detailsAction__nonPrimary: 'Негізгі ретінде орнату',
        primaryButton: 'Әптәпқалманы қосу',
        title: 'Web3 әптәпқалмалары',
        web3SelectSolanaWalletScreen: {
          subtitle: 'Есептік жазбаңызға қосу үшін Solana әмиянын таңдаңыз.',
          title: 'Solana әмиянын қосу',
        },
      },
    },
    usernamePage: {
      successMessage: 'Пайдаланушы аты жаңартылды.',
      title__set: 'Пайдаланушы атын орнату',
      title__update: 'Пайдаланушы атын жаңарту',
    },
    web3WalletPage: {
      removeResource: {
        messageLine1: '{{identifier}} есептік жазбадан жойылады.',
        messageLine2: 'Бұл әптәпқалма арқылы кіре алмайсыз.',
        successMessage: '{{web3Wallet}} жойылды.',
        title: 'Web3 әптәпқалманы жою',
      },
      subtitle__availableWallets: 'Есептік жазбаға қосылатын Web3 әптәпқалманы таңдаңыз.',
      subtitle__unavailableWallets: 'Қолжетімді Web3 әптәпқалмалар жоқ.',
      successMessage: 'Әптәпқалма есептік жазбаға қосылды.',
      title: 'Web3 әптәпқалманы қосу',
      web3WalletButtonsBlockButton: '{{provider|titleize}}',
    },
  },
  waitlist: {
    start: {
      actionLink: 'Кіру',
      actionText: 'Есептік жазбаңыз бар ма?',
      formButton: 'Күту тізіміне қосылу',
      subtitle: 'Электрондық поштаңызды енгізіңіз, біз сізбен хабарласамыз',
      title: 'Күту тізіміне қосылу',
    },
    success: {
      message: 'Жақында бетке қайта бағытталасыз...',
      subtitle: 'Даяр болған кезде хабарласамыз',
      title: 'Күту тізіміне қосылғаныңыз үшін рақмет!',
    },
  },
  web3SolanaWalletButtons: {
    connect: '{{walletName}} арқылы қосылу',
    continue: '{{walletName}} арқылы жалғастыру',
    noneAvailable:
      'Solana Web3 әмияндары табылмады. Web3 қолдайтын {{ solanaWalletsLink || link("wallet extension") }} орнатыңыз.',
  },
} as const;
